import { render, staticRenderFns } from "./Disclosure.vue?vue&type=template&id=c20e6686&scoped=true&"
import script from "./Disclosure.vue?vue&type=script&lang=js&"
export * from "./Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./Disclosure.vue?vue&type=style&index=0&id=c20e6686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20e6686",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardActions,VCardText})
